import React from "react";
import { Circle, Marker } from "react-native-maps";
import * as Colors from "../../../styles/colors";
import { IS_WEB } from "@services/Config";

export default function LocalDeviceMarker({
  coordinate: { marker, setMarker },
  radiosCircle,
}) {
  // Don't render map components on web
  if (IS_WEB) {
    return null;
  }
  
  // const showAllUnities = radiosCircle > 18000;
  return (
    <>
      {/* {!showAllUnities ? (
        <Circle center={marker} radius={radiosCircle} key={"LocalCircle"} />
      ) : null} */}
      <Marker
        key={-1}
        coordinate={marker}
        pinColor={Colors.PRIMARY}
        draggable={true}
        zIndex={1}
        style={{ position: "absolute", width: 50, height: 50 }}
        onDragEnd={(e) => {
          setMarker({
            latitude: e.nativeEvent.coordinate.latitude,
            longitude: e.nativeEvent.coordinate.longitude,
          });
        }}
      />
    </>
  );
}
